import { translation } from '@hh.ru/front-static-app';
import { Avatar, Text } from '@hh.ru/magritte-ui';
import { InfoCircleFilledSize24 } from '@hh.ru/magritte-ui/icon';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import Box from 'src/components/Box';
import Color from 'src/constants/color';
import useAnalyticsEventShownOnce from 'src/hooks/useAnalyticsEventShownOnce';

const TrlKeys = {
    message: 'statportal.report.dashboard.empty',
};

interface NoVacancyDataProps {
    vacancyId: number;
}

const NoVacancyData: TranslatedComponent<NoVacancyDataProps> = ({ vacancyId, trls }) => {
    const boxRef = useAnalyticsEventShownOnce({
        name: 'statportal_vacancy_conversion_no_vacancy_data',
        vacancyId,
    });

    return (
        <Box
            justifyContent="center"
            flexDirection="column"
            alignItems="center"
            padding={10}
            spacing={2}
            background={Color.White}
            borderRadius={3}
            boxRef={boxRef}
        >
            <Avatar
                size={48}
                mode="icon"
                style="secondary"
                aria-label={trls[TrlKeys.message]}
                icon={<InfoCircleFilledSize24 initialColor="tertiary" />}
                shapeCircle
            />
            <Text style="secondary">{trls[TrlKeys.message]}</Text>
        </Box>
    );
};

export default translation(NoVacancyData);
